import type { HistoryProject } from '../CuttingHistory';

/**
 * Block 14 «Раскрой» — экспорт видимого списка истории в CSV.
 * Чистая функция без побочных эффектов: BOM и скачивание — на стороне вызова
 * (`CuttingHistory.handleExportCsv`).
 *
 * Формат под русский Excel: разделитель полей «;» (запятая ломает раскладку
 * в один столбец), CRLF между строками. № порядковый вместо сырого UUID (P-042),
 * КИМ как процент (доля×100), колонка «Листов» (= sheetCount по контракту).
 * Квотирование — условное (RFC 4180): только при наличии «;», кавычки или
 * перевода строки в значении, иначе ячейка идёт как есть.
 */

/** Заголовок — вербатим, без кавычек (литерал без спецсимволов). */
const HEADER = '№;Название;Материал;Листов;КИМ;Дата';

/** Условное квотирование: оборачиваем только если внутри есть «;», кавычка или CR/LF. */
function escapeField(value: string): string {
  return /[;"\r\n]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;
}

export function buildHistoryCsv(rows: HistoryProject[]): string {
  const lines = [HEADER];
  rows.forEach((p, i) => {
    const cells = [
      String(i + 1),
      p.name,
      p.material,
      String(p.parts),
      p.kim === 0 ? '' : `${(p.kim * 100).toFixed(1)}%`,
      p.date,
    ];
    lines.push(cells.map(escapeField).join(';'));
  });
  return lines.join('\r\n');
}
